export const rulesViolated = {
    moneyLaundry: 'Hvidvask',
    fraud: 'Bedrageri',
    forgery: 'Dokumentfalsk',
    theft: 'Tyveri',
    secondOffence: 'Anden lovovertrædelse',
    dontKnow: 'Ved ikke',
};
